import { Tooltip } from "@material-ui/core";
import React, { useCallback } from "react";
import Info from "../../../assets/images/info-icon.svg";
import { wrapInTooltip } from "../../../utils/methods";

interface InputProps {
  value: string;
  title: string;
  setValue?: (_: string) => void;
  info?: string;
  onKeypress?: () => void;
  placeholder?: string;
}
interface CustomFormProps {
  customForm: any;
  info?: string;
  title: string;
}

const Input: React.FC<InputProps | CustomFormProps> = (props) => {
  const getWrapper = useCallback((component: any, title: string, info?: string) => {
    return (
      <div className="input-block">
        <div className="space-between">
          <span>{title}</span>
          {info && wrapInTooltip(<img src={Info} alt="info" />, info)}
        </div>
        {component}
      </div>
    );
  }, []);
  if ("value" in props) {
    const { value, setValue, onKeypress, title, info, placeholder } = props;
    const handleChange = (e: any) => {
      setValue && setValue(e?.target?.value);
    };
    const handleKeypress = (e: any) => {
      if (e.key === "Enter") onKeypress && onKeypress();
    };
    const disabled = !setValue;
    const inputComponent = (
      <input
        name={title}
        disabled={disabled}
        className={`d-input ${disabled ? "disabled" : ""}`}
        value={value || ""}
        onChange={handleChange}
        onKeyDown={handleKeypress}
        placeholder={placeholder}
      />
    );
    return getWrapper(inputComponent, title, info);
  } else {
    const { customForm, title, info } = props;
    return getWrapper(customForm, title, info);
  }
};

export default Input;
